module.exports = __webpack_public_path__ + "static/media/banner-work.2edbce9c.svg";